const initPickupBlockSplide = (section) => {
  if (!section || !window.Splide) return;

  const slider = section.querySelector(".select_collection__slider");
  if (!slider) return;

  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const hasInstance = slider.__pickupSplideInstance;

  if (isMobile && !hasInstance) {
    slider.__pickupSplideInstance = new Splide(slider, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      fixedWidth: "200px",
      gap: "16px",
      arrows: false,
      pagination: true,
      drag: true,
    });
    slider.__pickupSplideInstance.mount();
  }

  if (!isMobile && hasInstance) {
    hasInstance.destroy(true);
    slider.__pickupSplideInstance = null;
  }
};

const mountPickupBlockSplide = () => {
  document
    .querySelectorAll(".select_collection")
    .forEach((section) => initPickupBlockSplide(section));
};

document.addEventListener("DOMContentLoaded", () => {
  mountPickupBlockSplide();
  window.addEventListener("resize", () => mountPickupBlockSplide());
});

document.addEventListener("shopify:section:load", (event) => {
  const container = event.target;
  if (!container || !container.querySelector) return;
  const section = container.querySelector(".select_collection");
  initPickupBlockSplide(section);
});
